export default "__VITE_ASSET__C6KSnJVK__"